import React from "react";
import ContributorPage from "../../../components/_shared/ContributorPage";
import { ContributorType } from "../../../shared/constant";

const Composers = () => {
  return <ContributorPage contributorType={ContributorType.COMPOSER} />;
};

export default Composers;
